import {
  descargarPlantilla, leerLibro, buscarTabla, vacio, texto, sinDato, elegirDeLista, normalizarTexto,
  normalizarDireccion, momentoDe, leerMomento, ejemplosDirecciones, fechaDeMomento,
} from "./importar_masivo";
import {
  TIPOS_DOCUMENTO, TIPOS_VEHICULO, TIPOS_VISITANTE, TIPOS_PERMISO,
  nuevoPaseWeb, cambiosNuevoPase, fechaHoraDart, fechaDart, horaDart,
} from "./pase_visitante";

// Carga masiva de pases de visitantes desde Excel o CSV (solo web).
// Las primeras columnas son las de la tabla del listado, en el mismo orden, así que el archivo
// exportado se puede volver a cargar. Al final van tres columnas opcionales que la tabla no muestra.

export const ESTADOS_CARGA = ["Pendiente", "Notificado", "Ingreso", "Salida", "Anulado"];

export const COLUMNAS_PLANTILLA = [
  "DIRECCIÓN", "TIPO", "NOMBRE INVITADO", "TIPO DOCUMENTO", "N° DOCUMENTO", "TIPO PASE",
  "TIPO VEHÍCULO", "PLACA", "ESTADO", "FECHA CREACIÓN", "FECHA INGRESO", "FECHA SALIDA",
  "AUTORIZÓ INGRESO", "INICIO PASE LIMITADO", "FIN PASE LIMITADO",
];

export const EJEMPLOS_PLANTILLA = [
  ["TORRE 1 APARTAMENTO 302", "VISITANTE", "Carlos Gómez", "CÉDULA DE CIUDADANIA", "1020304050", "TEMPORAL", "CARRO", "ABC123", "Salida", "07/10/2026 09:30", "07/10/2026 09:35", "07/10/2026 12:10", "María López", "", ""],
  ["MANZANA C CASA 2", "VISITANTE", "Luisa Martínez", "CÉDULA DE CIUDADANIA", "52123456", "TEMPORAL", "", "", "Ingreso", "08/10/2026 15:00", "", "", "", "", ""],
  ["CASA 15", "HUESPED", "Pedro Ruiz", "PASAPORTE", "AB123456", "LIMITADO", "MOTO", "XYZ12A", "Pendiente", "", "", "", "Jorge Díaz", "10/10/2026", "15/10/2026"],
];

export const descargarPlantillaVisitantes = () => descargarPlantilla({
  archivo: "plantilla_visitantes.xlsx",
  hoja: "Visitantes",
  columnas: COLUMNAS_PLANTILLA,
  ejemplos: EJEMPLOS_PLANTILLA,
  anchos: [26, 12, 22, 24, 16, 12, 14, 10, 11, 18, 18, 18, 20, 20, 18],
  instrucciones: [
    ["DIRECCIÓN", "Sí", "Vivienda que recibe la visita, igual que en CoordiPH: TORRE 1 APARTAMENTO 302, MANZANA C CASA 2, CASA 15, ADMINISTRACIÓN o PORTERIA."],
    ["TIPO", "No", "VISITANTE o HUESPED. Si la deja vacía queda VISITANTE. Un HUESPED solo puede tener pase LIMITADO."],
    ["NOMBRE INVITADO", "Sí", "Nombre completo del visitante."],
    ["TIPO DOCUMENTO", "No", `${TIPOS_DOCUMENTO.join(", ")}. También sirve CC, TI, CE o RC. Si la deja vacía queda CÉDULA DE CIUDADANIA.`],
    ["N° DOCUMENTO", "Sí", "Número del documento, mínimo 6 caracteres."],
    ["TIPO PASE", "No", "TEMPORAL (un solo día), LIMITADO (entre dos fechas) o PERMANENTE. Si la deja vacía queda TEMPORAL."],
    ["TIPO VEHÍCULO", "No", "CARRO o MOTO. Déjela vacía si llega a pie."],
    ["PLACA", "No", "Placa del vehículo, como ABC123."],
    ["ESTADO", "No", "Pendiente, Notificado, Ingreso, Salida o Anulado. Si la deja vacía: Salida si escribió la fecha de salida, Ingreso si es pase TEMPORAL, y Pendiente para LIMITADO o PERMANENTE."],
    ["FECHA CREACIÓN", "No", "Día y hora en que se creó el pase, como 07/10/2026 09:30 (día/mes/año y hora de 24 horas). Si la deja vacía se usa la fecha y hora de la carga."],
    ["FECHA INGRESO", "No", "Día y hora en que entró. Si el estado es Ingreso o Salida y la deja vacía, se usa la fecha de creación."],
    ["FECHA SALIDA", "Solo si está en Salida", "Día y hora en que salió. No puede ser antes del ingreso."],
    ["AUTORIZÓ INGRESO", "No", "Persona que autorizó la visita. Si la deja vacía se usa el nombre de quien hace la carga."],
    ["INICIO PASE LIMITADO", "Solo si es LIMITADO", "Primer día en que el pase sirve, como 10/10/2026."],
    ["FIN PASE LIMITADO", "Solo si es LIMITADO", "Último día en que el pase sirve, como 15/10/2026. No puede ser antes del inicio."],
  ],
});

// El orden importa: la primera regla que coincide decide el campo.
const REGLAS_COLUMNAS = [
  ["inicioLimitado", /\b(inicio|desde)\b/],
  ["finLimitado",    /\b(fin|final|hasta|vence|vencimiento)\b/],
  ["fechaSalida",    /\bsalida\b/],
  ["fechaIngreso",   /\b(fecha|hora)\b.*\bingreso\b/],
  ["fecha",          /\b(fecha|creacion)\b/],
  ["autorizo",       /\b(autorizo|autoriza|autorizado|usuario)\b/],
  ["tipoDocumento",  /\btipo\b.*\bdocumento\b/],
  ["documento",      /\b(documento|cedula|identificacion|n|no|numero)\b/],
  ["tipoPermiso",    /\b(pase|permiso)\b/],
  ["tipoVehiculo",   /\b(vehiculo|carro|moto)\b/],
  ["placa",          /\bplacas?\b/],
  ["estado",         /\bestado\b/],
  ["nombre",         /\b(nombre|invitado|visitante)\b/],
  ["tipoVisitante",  /^tipo$/],
  ["vivienda",       /\b(direccion|vivienda|inmueble|apartamento|apto|casa|destino|unidad)\b/],
];

const esEncabezado = (c) => c.vivienda !== undefined && c.nombre !== undefined;

const ALIAS_DOCUMENTO = {
  cc: "CÉDULA DE CIUDADANIA", cedula: "CÉDULA DE CIUDADANIA", "cedula ciudadania": "CÉDULA DE CIUDADANIA",
  ti: "TARJETA DE IDENTIDAD", rc: "REGISTRO CIVIL", ce: "CÉDULA DE EXTRANJERIA", "cedula extranjeria": "CÉDULA DE EXTRANJERIA",
  pp: "PASAPORTE", pa: "PASAPORTE",
};

const tipoDocumentoDe = (valor) => elegirDeLista(valor, TIPOS_DOCUMENTO) || ALIAS_DOCUMENTO[normalizarTexto(valor)];

// ahora: fecha y hora de la carga. Devuelve { encontroEncabezado, registros, errores, ejemplos }.
// Cada registro: { fila, original, vivienda, tipoVisitante, nombre, tipoDocumento, documento, tipoPermiso,
//   tipoVehiculo, placa, estado, autorizo, creacion, ingreso, salida ({ fecha, hora } o null),
//   inicioLimitado, finLimitado ("aaaa-mm-dd" o "") }.
export const leerLibroVisitantes = (libro, ahora = new Date()) => {
  const tabla = buscarTabla(libro, REGLAS_COLUMNAS, esEncabezado);
  if (!tabla) return { encontroEncabezado: false, registros: [], errores: [], ejemplos: [] };

  const actual = momentoDe(ahora);
  const momentoActual = `${actual.fecha} ${actual.hora}`;
  const { filas, indice, columnas } = tabla;
  const celda = (fila, campo) => (columnas[campo] !== undefined ? fila[columnas[campo]] : "");
  const registros = [];
  const errores = [];
  const unir = (m) => `${m.fecha} ${m.hora}`;

  filas.slice(indice + 1).forEach((fila, i) => {
    const numeroFila = indice + i + 2;
    if (fila.every(vacio)) return;

    const original = texto(celda(fila, "vivienda"));
    const nombre = texto(celda(fila, "nombre"));
    const documento = texto(celda(fila, "documento")).replace(/\s/g, "");
    const autorizo = texto(celda(fila, "autorizo"));
    const placa = sinDato(celda(fila, "placa")) ? "" : texto(celda(fila, "placa")).toUpperCase().replace(/[^A-Z0-9]/g, "");
    const valores = {
      tipoVisitante: texto(celda(fila, "tipoVisitante")),
      tipoDocumento: texto(celda(fila, "tipoDocumento")),
      tipoPermiso: texto(celda(fila, "tipoPermiso")),
      tipoVehiculo: sinDato(celda(fila, "tipoVehiculo")) ? "" : texto(celda(fila, "tipoVehiculo")),
      estado: texto(celda(fila, "estado")),
    };

    const problemas = [];
    const faltan = [];
    if (!original) faltan.push("la dirección");
    if (!nombre) faltan.push("el nombre del invitado");
    if (!documento) faltan.push("el número de documento");
    if (faltan.length) problemas.push(`falta ${faltan.join(", ")}`);
    else if (documento.length < 6) problemas.push("el número de documento debe tener mínimo seis caracteres");

    const elegir = (campo, lista, nombreCampo, porDefecto, buscar = (v) => elegirDeLista(v, lista)) => {
      if (!valores[campo]) return porDefecto;
      const elegido = buscar(valores[campo]);
      if (!elegido) problemas.push(`${nombreCampo} "${valores[campo]}" no existe; use ${lista.join(", ")}`);
      return elegido;
    };
    const tipoVisitante = elegir("tipoVisitante", TIPOS_VISITANTE, "el tipo", "VISITANTE");
    const tipoDocumento = elegir("tipoDocumento", TIPOS_DOCUMENTO, "el tipo de documento", TIPOS_DOCUMENTO[0], tipoDocumentoDe);
    const tipoPermiso = elegir("tipoPermiso", TIPOS_PERMISO, "el tipo de pase", "TEMPORAL");
    const tipoVehiculo = elegir("tipoVehiculo", TIPOS_VEHICULO, "el tipo de vehículo", "CARRO");

    if (tipoVisitante === "HUESPED" && tipoPermiso && tipoPermiso !== "LIMITADO") {
      problemas.push("un HUESPED solo puede tener pase LIMITADO");
    }

    const creacionLeida = leerMomento(celda(fila, "fecha"), "", "de creación", problemas);
    const ingresoLeido = leerMomento(celda(fila, "fechaIngreso"), "", "de ingreso", problemas);
    const salidaLeida = leerMomento(celda(fila, "fechaSalida"), "", "de salida", problemas);
    const creacion = creacionLeida
      ? { fecha: creacionLeida.fecha, hora: creacionLeida.hora || "00:00" }
      : actual;

    let estado = elegir("estado", ESTADOS_CARGA, "el estado", null);
    if (!valores.estado) {
      estado = salidaLeida ? "Salida" : ingresoLeido || tipoPermiso === "TEMPORAL" ? "Ingreso" : "Pendiente";
    }

    let ingreso = null;
    let salida = null;
    if (estado === "Ingreso" || estado === "Salida") {
      ingreso = ingresoLeido ? { fecha: ingresoLeido.fecha, hora: ingresoLeido.hora || creacion.hora } : creacion;
      if (unir(ingreso) < unir(creacion)) problemas.push("la fecha de ingreso es anterior a la de creación");
      else if (unir(ingreso) > momentoActual) problemas.push("la fecha de ingreso es posterior a hoy");
    }
    if (estado === "Salida") {
      if (!salidaLeida && !problemas.some(p => p.includes("de salida"))) problemas.push("está en Salida pero falta la fecha de salida");
      if (salidaLeida && ingreso) {
        salida = { fecha: salidaLeida.fecha, hora: salidaLeida.hora || ingreso.hora };
        if (unir(salida) < unir(ingreso)) problemas.push("la fecha de salida es anterior a la de ingreso");
        else if (unir(salida) > momentoActual) problemas.push("la fecha de salida es posterior a hoy");
      }
    }
    if (unir(creacion) > momentoActual) problemas.push("la fecha de creación es posterior a hoy");

    let inicioLimitado = "";
    let finLimitado = "";
    if (tipoPermiso === "LIMITADO") {
      const inicio = leerMomento(celda(fila, "inicioLimitado"), "", "de inicio del pase", problemas);
      const fin = leerMomento(celda(fila, "finLimitado"), "", "de fin del pase", problemas);
      if (!inicio || !fin) {
        if (!problemas.some(p => p.includes("del pase"))) problemas.push("es pase LIMITADO pero falta la fecha de inicio o de fin del pase");
      } else if (fin.fecha < inicio.fecha) {
        problemas.push("el fin del pase limitado es anterior al inicio");
      } else {
        inicioLimitado = inicio.fecha;
        finLimitado = fin.fecha;
      }
    }

    if (problemas.length) {
      errores.push({ fila: numeroFila, texto: problemas.join("; ") });
      return;
    }

    registros.push({
      fila: numeroFila,
      original,
      vivienda: normalizarDireccion(original),
      tipoVisitante,
      nombre,
      tipoDocumento,
      documento,
      tipoPermiso,
      tipoVehiculo,
      placa,
      estado,
      autorizo,
      creacion,
      ingreso,
      salida,
      inicioLimitado,
      finLimitado,
    });
  });

  return { encontroEncabezado: true, registros, errores, ejemplos: ejemplosDirecciones(registros) };
};

export const leerArchivoVisitantes = async (archivo, ahora = new Date()) =>
  leerLibroVisitantes(await leerLibro(archivo), ahora);

// ---------- Guardado ----------

// Rutas y valores de Firebase de un pase leído del archivo (mismos campos que crearlo a mano).
export const cambiosPaseCargado = (r, i, { nit, usuario, ahora }) => {
  const creacion = fechaDeMomento(r.creacion, i);
  const momento = (m) => (m ? fechaHoraDart(fechaDeMomento(m, i)) : null);
  return cambiosNuevoPase(nit, nuevoPaseWeb({
    casa: r.vivienda,
    usuario: r.autorizo || usuario,
    nombreDocumentoVisitante: r.nombre,
    tipoDocumentoVisitante: r.tipoDocumento,
    numeroDocumentoVisitante: r.documento,
    tipoVehiculo: r.tipoVehiculo,
    placasVehiculo: r.placa,
    existeVehiculo: r.placa.length > 0,
    estado: r.estado,
    tipoPermiso: r.tipoPermiso,
    tipoVisitante: r.tipoVisitante,
    fechaCreacionRegistro: fechaHoraDart(creacion),
    fechaHoraIngreso: momento(r.ingreso),
    fechaHoraSalida: momento(r.salida),
    autorizaIngreso: r.ingreso ? usuario : null,
    autorizaSalida: r.salida ? usuario : null,
    ...(r.estado === "Anulado" ? { anulaIngreso: usuario, fechaHoraAnulacion: fechaHoraDart(ahora) } : {}),
    fechaTemporalPermiso: r.tipoPermiso === "TEMPORAL" ? fechaDart(creacion) : "",
    fechaInicioPermiso: r.inicioLimitado,
    fechaFinalPermiso: r.finLimitado,
    horaTemporalPermiso: horaDart(creacion),
  }));
};
